// Generated by CoffeeScript 1.11.1
(function() {
  module.exports = {
    toPng: function() {
      return this.layer.image.toPng();
    },
    saveAsPng: function(output) {
      return this.layer.image.saveAsPng(output);
    }
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/nodes/build_preview.js
// module id = 77
// module chunks = 0